import { Notice, StatusTag } from '@/design-system/components/ui';
import { useI18n } from '@/i18n/context';

/** Shown instead of silently failing when Supabase is not configured. */
export function BackendNotice({ compact = false }: { compact?: boolean }) {
  const { t } = useI18n();
  return (
    <div style={{ padding: compact ? 0 : 'var(--space-8) var(--gutter)', maxInlineSize: 720, marginInline: 'auto' }}>
      <Notice tone="warning" title={t.common.notConfigured.title} action={<StatusTag kind="requiresCredentials" />}>
        {t.common.notConfigured.body}
      </Notice>
    </div>
  );
}
